<h2 class="text-xl font-bold mb-6">
  {{ key() | transloco }}
</h2>
